import { createAsyncThunk } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

//Include Both Helper File with needed methods
import {
	getSettingsList as getSettingsListApi,
	getSettings as getSettingsApi,
	addNewSettings as addNewSettingsApi,
	updateSettings as updateSettingsApi,
	deleteSettings as deleteSettingsApi,
	baseSettingsColor as baseSettingsColorApi,
	baseSettingsLogin as baseSettingsLoginApi,
	baseSettingsHeader as baseSettingsHeaderApi,
	getModulesList as getModulesListApi,
	getModule as getModuleApi,
	addNewModule as addNewModuleApi,
	updateModule as updateModuleApi,
	deleteModule as deleteModuleApi,
	
	getModuleEstablishmentList as getModuleEstablishmentListApi,
	getModuleEstablishment as getModuleEstablishmentApi,
	addNewModuleEstablishment as addNewModuleEstablishmentApi,
	updateModuleEstablishment as updateModuleEstablishmentApi,
	deleteModuleEstablishment as deleteModuleEstablishmentApi,
	getModuleUsageFactList as getModuleUsageFactListApi,
} from '../../helpers/settings/backend_helper';

export const getSettingsList = createAsyncThunk('settings/getSettingsList', async () => {
	try {
		const response = getSettingsListApi();
		return response;
	} catch (error) {
		throw new Error(error);
	}
});

export const getSettings = createAsyncThunk('settings/getSettings', async settings_id => {
	try {
		const response = getSettingsApi(settings_id);
		return response;
	} catch (error) {
		throw new Error(error);
	}
});

export const addNewSettings = createAsyncThunk('settings/addNewSettings', async settings => {
	try {
		const response = addNewSettingsApi(settings);
		toast.success('Settings agregado exitosamente.', { autoClose: 3000 });
		return response;
	} catch (error) {
		toast.error('Error al agregar settings.', { autoClose: 3000 });
		throw new Error(error);
	}
});

export const updateSettings = createAsyncThunk('settings/updateSettings', async (settings) => {
		try {
			const response = updateSettingsApi(settings);
			toast.success('Settings actualizado exitosamente', { autoClose: 3000 });
			return response;
		} catch (error) {
			toast.error('Error al actualizar settings.', { autoClose: 3000 });
			throw new Error(error);
		}
	}
);

export const deleteSettings = createAsyncThunk('settings/deleteSettings', async settings => {
	try {
		const response = await deleteSettingsApi(settings);
		toast.success('Settings eliminado exitosamente.', { autoClose: 3000 });
		return { settings, ...response };
	} catch (error) {
		toast.error('Error al eliminar settings.', { autoClose: 3000 });
		throw new Error(error);
	}
});



export const baseSettingsColor = createAsyncThunk('settings/baseSettingsColor', async () => {
	try {
		const response = baseSettingsColorApi();
		return response;
	} catch (error) {
		throw new Error(error);
	}
});

export const baseSettingsLogin = createAsyncThunk('settings/baseSettingsLogin', async () => {
	try {
		const response = baseSettingsLoginApi();
		return response;
	} catch (error) {
		throw new Error(error);
	}
});

export const baseSettingsHeader = createAsyncThunk('settings/baseSettingsHeader', async () => {
	try {
		const response = baseSettingsHeaderApi();
		return response;
	} catch (error) {
		throw new Error(error);
	}
});


export const getModulesList = createAsyncThunk('settings/getModulesList', async () => {
	try {
		const response = getModulesListApi();
		return response;
	} catch (error) {
		throw new Error(error);
	}
});

export const getModule = createAsyncThunk('settings/getModule', async module_id => {
	try {
		const response = getModuleApi(module_id);
		return response;
	} catch (error) {
		throw new Error(error);
	}
});

export const addNewModule = createAsyncThunk('settings/addNewModule', async module => {
	try {
		const response = addNewModuleApi(module);
		toast.success('Módulo agregado exitosamente.', { autoClose: 3000 });
		return response;
	} catch (error) {
		toast.error('Error al agregar módulo.', { autoClose: 3000 });
		throw new Error(error);
	}
});

export const updateModule = createAsyncThunk('settings/updateModule', async module => {
	try {
		const response = updateModuleApi(module);
		toast.success('Módulo actualizado exitosamente', { autoClose: 3000 });
		return response;
	} catch (error) {
		toast.error('Error al actualizar módulo.', { autoClose: 3000 });
		throw new Error(error);
	}
});

export const deleteModule = createAsyncThunk('settings/deleteModule', async module => {
	try {
		const response = await deleteModuleApi(module);
		toast.success('Módulo eliminado exitosamente.', { autoClose: 3000 });
		return { module, ...response };
	} catch (error) {
		toast.error('Error al eliminar módulo.', { autoClose: 3000 });
		throw new Error(error);
	}
});


export const getModuleEstablishmentList = createAsyncThunk('settings/getModuleEstablishmentList', async (params) => {
	try {
		const response = getModuleEstablishmentListApi(params);
		return response;
	} catch (error) {
		throw new Error(error);
	}
});

export const getModuleEstablishment = createAsyncThunk('settings/getModuleEstablishment', async (params) => {
	try {
		const response = getModuleEstablishmentApi(params);
		return response;
	} catch (error) {
		throw new Error(error);
	}
});

export const addNewModuleEstablishment = createAsyncThunk('settings/addNewModuleEstablishment', async module_establishment => {
	try {
		const response = addNewModuleEstablishmentApi(module_establishment);
		return response;
	} catch (error) {
		toast.error('Error al agregar module_establishment.', { autoClose: 3000 });
		throw new Error(error);
	}
});

export const updateModuleEstablishment = createAsyncThunk('settings/updateModuleEstablishment', async (module_establishment) => {
		try {
			const response = updateModuleEstablishmentApi(module_establishment);
			return response;
		} catch (error) {
			toast.error('Error al actualizar module_establishment.', { autoClose: 3000 });
			throw new Error(error);
		}
	}
);

export const deleteModuleEstablishment = createAsyncThunk('settings/deleteModuleEstablishment', async module_establishment => {
	try {
		const response = await deleteModuleEstablishmentApi(module_establishment);
		return { module_establishment, ...response };
	} catch (error) {
		toast.error('Error al eliminar module_establishment.', { autoClose: 3000 });
		throw new Error(error);
	}
});

export const getModuleUsageFactList = createAsyncThunk(
	'settings/getModuleUsageFactList',
	async (params) => {
		try {
			const response = getModuleUsageFactListApi(params);
			return response;
		} catch (error) {
			throw new Error(error);
		}
	}
);